const CARD_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  STOLEN: 'stolen',
  LOST: 'lost',
  FROZEN: 'frozen',
  CLOSED_BY_CUSTOMER: 'closed_by_customer',
  SUSPECTED_FRAUD: 'suspected_fraud'
};

const UNIT_CARD_STATUS = {
  INACTIVE: 'Inactive',
  ACTIVE: 'Active',
  STOLEN: 'Stolen',
  LOST: 'Lost',
  FROZEN: 'Frozen',
  CLOSED_BY_CUSTOMER: 'ClosedByCustomer',
  SUSPECTED_FRAUD: 'SuspectedFraud'
};

const UNIT_CARD_TYPE = {
  BUSINESS_DEBIT_CARD: 'businessDebitCard',
  BUSINESS_VIRTUAL_DEBIT_CARD: 'businessVirtualDebitCard'
};

const CARD_TYPE = {
  BUSINESS_DEBIT_CARD: 'business_debit_card',
  BUSINESS_VIRTUAL_DEBIT_CARD: 'business_virtual_debit_card'
};

const CARD_ACTIVATION_STATUSES = {
  FAILED: 'failed'
};

const CARD_PIN_STATUS = {
  SET: 'set',
  NOTSET: 'notset'
};

const UNIT_CARD_PIN_STATUS = {
  SET: 'Set',
  NOTSET: 'NotSet'
};

const UNIT_PIN_STATUS_TYPE = 'pinStatus';

const RESET_ACTIVATION_HOURS = 24;

const MAXIMUM_ACTIVATION_FAILED_ATTEMPTS = 3;

module.exports = {
  CARD_ACTIVATION_STATUSES,
  CARD_PIN_STATUS,
  CARD_STATUS,
  CARD_TYPE,
  UNIT_CARD_PIN_STATUS,
  UNIT_CARD_STATUS,
  UNIT_CARD_TYPE,
  UNIT_PIN_STATUS_TYPE,
  RESET_ACTIVATION_HOURS,
  MAXIMUM_ACTIVATION_FAILED_ATTEMPTS
};
